//import gsap from 'gsap'


class App {

  constructor($) {
    this.create()
  }

  create() {

    $('body').addClass('loaded')

    console.log('loaded');

    $('#mc-embedded-subscribe-form').on('submit', (e)=>{
        e.preventDefault()
        const form = $('#mc-embedded-subscribe-form')
        const url = form.attr('action')
        const email = form.find('#mail').val()


        console.log(email);

        this.mailchimp(email, url).done(
          (data) => {
            if (data.result != "success") {
              //  console.log('error', data);
                this.showError(data.msg)
            } else {
                this.showError(data.msg)
            }
        }).fail(
          (err) => {
            //  console.log('err', err);
              this.showError(err.msg)
          }
        )
    })
  }

  showError(error){

      $('.errors-text').html(error)
  }

  mailchimp(email, url) {

    var data = {
      'EMAIL': email,
      utf8: '✓'
    };

    var promise = $.ajax({
        url: url ,
        method: 'post',
        data: data,
        cache       : false,
        dataType    : 'jsonp',
        jsonp: 'c',
        contentType: "application/json; charset=utf-8"
    })

    return promise;
  }


}

module.exports = App
